import Retracked from 'js/app/retracked';

export type EventData = {
  namespace: {
    app: string;
    page: string;
  };
};

/**
 * Tracks authentication attempts.
 *
 * This function sends a tracking event for authentication attempts using Retracked.
 * It tracks the event with the given event data, and by default, it sets the authentication type to 'auth'.
 *
 * @param {EventData} _eventData - The event data for tracking the authentication attempt.
 * @param {string} [authType='auth'] - The type of authentication to be tracked (e.g., 'login', 'signup'). Default is 'auth'.
 */
export const trackAuthAttempts = (_eventData: EventData, authType = 'auth') => {
  if (_eventData && _eventData.namespace) {
    Retracked.trackComponent(_eventData, {}, `${authType}_attempt`, 'submit');
  }
};
